import React, { useState } from 'react';
import styles from '../../src/assets/scss/UserInvite.module.scss';
import Pagination from '../Components/Common/Pagination';
import { useGetMyInvitesQuery, useAcceptInviteFromMutation } from '../slices/admin/admin';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const InviteFrom = () => {
    const navigate = useNavigate();

    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setSearchValue] = useState('');
    const [selectedStatus, setSelectedStatus] = useState('');
    const [acceptInvite] = useAcceptInviteFromMutation();

    const rowsPerPage = 10;
    const offset = (currentPage - 1) * rowsPerPage + 1;

    const handleClickInvite = () => {
        navigate('/dashboard/AddInvite');
    };

    const statusParam =
        selectedStatus === 'Accepted'
            ? true
            : selectedStatus === 'Not Accepted'
                ? false
                : undefined;

    const {
        data: apiData = {},
        isLoading,
        isError,
        error,
    } = useGetMyInvitesQuery({
        offset,
        limit: rowsPerPage,
        search: searchValue,
        isAccepted: statusParam,
    });

    const invites = apiData.data || [];
    const totalCount = apiData.total || 0;
    const totalPages = Math.ceil(totalCount / rowsPerPage);

    const handleClearFilters = () => {
        setSearchValue('');
        setSelectedStatus('');
        setCurrentPage(1);
    };

    const handleAccept = async (id) => {
        try {
            const res = await acceptInvite(id).unwrap();
            toast.success(res.message || 'Invite accepted successfully');
        } catch (err) {
            toast.error(err?.data?.message || 'Failed to accept invite');
        }
    };

    return (
        <>
            <div className={styles.topBar}>
                <div className={styles.filterContainer}>
                    <input
                        type="text"
                        placeholder="Search here..."
                        className={styles.searchInput}
                        value={searchValue}
                        onChange={(e) => {
                            setSearchValue(e.target.value);
                            setCurrentPage(1);
                        }}
                    />
                    <select
                        className={styles.statusSelect}
                        value={selectedStatus}
                        onChange={(e) => {
                            setSelectedStatus(e.target.value);
                            setCurrentPage(1);
                        }}
                    >
                        <option value="">All</option>
                        <option value="Accepted">Accepted</option>
                        <option value="Not Accepted">Not Accepted</option>
                    </select>
                    <button className={styles.clearBtn} onClick={handleClearFilters}>
                        Clear All
                    </button>
                </div>
                <div>
                    <button className={styles.sendInvite} onClick={handleClickInvite}>
                        + Send Invite
                    </button>
                </div>
            </div>

            {isLoading ? (
                <p>Loading...</p>
            ) : isError ? (
                <p>{error?.data?.message || 'Failed to load data'}</p>
            ) : (
                <table className={styles.table}>
                    <thead>
                        <tr>
                            {/* <th>Name</th> */}
                            <th>Org Name</th>
                            <th>Phone Number</th>
                            <th>User Type</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {invites.length === 0 ? (
                            <tr>
                                <td colSpan="6" className={styles.noData}>No record found</td>
                            </tr>
                        ) : (
                            invites.map((user) => (
                                <tr key={user._id}>
                                    {/* <td>{user.name}</td> */}
                                     <td>{user.store?.storeName || '-'}</td>
                                    <td className='notranslate'>{user.createdBy?.phone || '-'}</td>
                                    <td>{user.type}</td>
                                    <td className={user.isAccepted ? styles.active : styles.inactive}>
                                        {user.isAccepted ? 'Accepted' : 'Not Accepted'}
                                    </td>
                                    <td>
                                        {!user.isAccepted && (
                                            <button
                                                className={styles.acceptBtn}
                                                onClick={() => handleAccept(user._id)}
                                            >
                                                Accept
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            )}

            <div className={styles.margin}>
                {totalCount > 0 && (
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={(page) => setCurrentPage(page)}
                    />
                )}
            </div>
        </>
    );
};

export default InviteFrom;
